/*
  Copyright (c) 2018-present, Accuracy.
  All rights reserved.
*/
import {createStyles, StyleRules, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React, {memo} from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

//----------------------------------------------------------------------------------------------------------------------
//- Styles
//----------------------------------------------------------------------------------------------------------------------
export type FooterClassKey = 'root' | 'link';

const useStyles = makeStyles<Theme, {}, FooterClassKey>(
  (): StyleRules<FooterClassKey> =>
    createStyles({
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        padding: '26px clamp(20px, 4vw, 56px)',
        borderTop: '1px solid var(--color-rule-header)',
        background: 'var(--color-bg)',
        fontFamily: 'var(--font-body)',
        fontSize: '11px',
        letterSpacing: '.12em',
        textTransform: 'uppercase',
        color: 'var(--color-text-faint)'
      },
      link: {
        color: 'var(--color-text-faint)',
        textDecoration: 'underline',
        '&:hover': {
          color: 'var(--color-text-strong)'
        }
      }
    }),
  {
    name: 'Footer'
  });

//----------------------------------------------------------------------------------------------------------------------
//- Component
//----------------------------------------------------------------------------------------------------------------------
export type FooterProps = {
  className?: string;
};

export default memo(({className}: FooterProps) => {
  // hooks
  const classes = useStyles({});
  const {t} = useTranslation('common');

  return (
    <footer className={classNames(classes.root, className)}>
      <span>© Copyright - Pierre CASTAY - {t('footer.reserved')} - <Link className={classes.link} to={'/legal'}>{t('footer.legal')}</Link></span>
      <span>{t('footer.made')} N. CASTAY - webmaster@pierre-castay.fr</span>
    </footer>
  );
});
